import { Component } from '@angular/core';
import { BackgroundDecorationComponent } from '../shared-components/background-decoration/background-decoration.component';
import { RedirectTimerComponent } from '../shared-components/redirect-timer/redirect-timer.component';
import { MatIconModule } from '@angular/material/icon';
@Component({
  selector: 'app-page-not-allowed',
  templateUrl: './page-not-allowed.component.html',
  styleUrl: './page-not-allowed.component.scss',
  imports: [
    BackgroundDecorationComponent,
    RedirectTimerComponent,
    MatIconModule,
  ],
})
export class PageNotAllowedComponent {}
